import styled from 'styled-components';
import { containerStyle } from '../designSystem';

const AnnuaireContainer = styled.div`
  ${containerStyle}
`;

export default AnnuaireContainer;
